import * as apiGetCampusLevelChanges from "@/api/campus/getCampusLevelChanges.js";
import * as apiGetPayratePlandayChanges from "@/api/campus/getPayratePlandayChanges.js";
import * as apiExportPayrateChanges from "@/api/campus/exportPayrateChanges.js";
import * as apiGetUserVenuesDetails from "@/api/campus/getUserVenuesDetails.js";

import _ from "lodash";

export default {
  namespaced: true,
  state: {
    loading: false,
    campusLevelChanges: [],
    plandayPayrateChanges: [],
    plandayPayrateChangesWithErrors: [],
    numLevelOne: 0,
    numLevelTwo: 0,
    numLevelThree: 0,
    userVenuesDetails: null
  },
  mutations: {
    gotCampusLevelChanges(state, changes) {
      state.campusLevelChanges = changes;
      state.numLevelOne = changes.filter(e => e.levelTo == 1).length
      state.numLevelTwo = changes.filter(e => e.levelTo == 2).length
      state.numLevelThree = changes.filter(e => e.levelTo == 3).length
    },

    isLoading(state, loading) {
      state.loading = loading;
    },

    gotPlandayPayrateChanges(state, changes) {
      state.plandayPayrateChanges = changes.filter(e => !e.hasError);
      state.plandayPayrateChangesWithErrors = changes.filter(e => e.hasError);
    },

    gotUserVenuesDetails(state, payload) {
      state.userVenuesDetails = payload
    },
  },
  actions: {
    async exportPayrateChanges({ commit }) {
      commit('isLoading', true)


      var result = await apiExportPayrateChanges.post()

      var file = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      file.name = 'export.xlsx'
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);

      commit('isLoading', false)
    },
    async getCampusLevelChanges({ commit }) {
      commit("isLoading", true);

      const result = await apiGetCampusLevelChanges.get();

      if (result) {
        commit("gotCampusLevelChanges", result);
      }

      commit("isLoading", false);
    },
    async getPayratePlandayChanges({ commit }) {
      commit("isLoading", true);

      const result = await apiGetPayratePlandayChanges.get();

      if (result) {
        commit("gotPlandayPayrateChanges", result);
      }

      commit("isLoading", false);
    },

    async getUserVenuesDetails({ commit, state }, force = true) {
      if (!force && state.userVenuesDetails !== null) return;
      const result = await apiGetUserVenuesDetails.get();
      if (result) commit("gotUserVenuesDetails", result);
    },
  },
  getters: {
    campusLevelChanges: state => state.campusLevelChanges,
    plandayPayrateChanges: state => state.plandayPayrateChanges,
    plandayPayrateChangesWithErrors: state => state.plandayPayrateChangesWithErrors,
    numLevelOne: state => state.numLevelOne,
    numLevelTwo: state => state.numLevelTwo,
    numLevelThree: state => state.numLevelThree,
    numLevelChangePayrates: state => state.plandayPayrateChanges.filter(e => e.reason == 1).length,
    numConsolidatedPayrates: state => state.plandayPayrateChanges.filter(e => e.reason == 2).length,
    numSalaryIncreasePayrates: state => state.plandayPayrateChanges.filter(e => e.reason == 3).length,
    userVenuesDetails: state => state.userVenuesDetails,
  }
};
